(() => {
  const initRail = (rail) => {
    if (rail.dataset.nhRailReady === 'true') return;

    const viewport = rail.querySelector('[data-rail-viewport]');
    const previous = rail.querySelector('[data-rail-prev]');
    const next = rail.querySelector('[data-rail-next]');
    if (!viewport || !previous || !next) return;

    rail.dataset.nhRailReady = 'true';

    const updateControls = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      previous.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maxScroll - 2;
    };

    const move = (direction) => {
      const distance = Math.max(280, Math.round(viewport.clientWidth * 0.82));
      viewport.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    viewport.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateControls);
      observer.observe(viewport);
    }

    updateControls();
  };

  const init = () => document.querySelectorAll('[data-nh-product-rail]').forEach(initRail);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
